import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

const { TextArea } = Input;
const { Option } = Select;



interface BcModalProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    initialValues?: {
        bc_id?: number;
        bc_name?: string;
    } | null;
    isEditMode?: boolean;
}

const BcModal: React.FC<BcModalProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);

    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };


    // Handle form submit
    const handleAddSc = async (values: any) => {
        try {
            const dataVal = {
                bc_name: values.bc_name,
                ...(initialValues?.bc_id && { bc_id: initialValues.bc_id }),
            };
            const url = isEditMode
                ? 'edit-base-color'
                : 'add-base-color';

            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: dataVal,
            });
            console.log(dataVal);

            onCreate(data); // Notify parent about success
            showSuccess(
                isEditMode ? 'Base Color updated successfully!' : 'Base Color created successfully!',
            );
            form.resetFields();

            if (isModalClose) {
                onCancel(); // Close modal only if Submit button was clicked (not Submit & Create New)
            }
        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} Base Color`);
        }
    };

    // When modal opens or mode changes, set/reset form fields accordingly
    useEffect(() => {
        if (visible && isEditMode && initialValues) {
            form.setFieldsValue({
                bc_name: initialValues.bc_name,
            });
        } else if (visible) {
            form.resetFields();
        }
        
    }, [visible, isEditMode, initialValues, form]);

    const bcName = Form.useWatch('bc_name', form) || '#ccc';



    return (
        <Modal
            title={isEditMode ? 'Edit Base Color' : 'Add New Base Color'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="90%"
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddSc}
                autoComplete="off"
            >
                <Row gutter={16} align="middle">
                    <Col span={12}>
                        <Form.Item
                            name="bc_name"
                            className='px-8'
                            label={
                                <span>
                                    Base Color &nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 25 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the Base Color Name' },
                                { max: 25, message: 'Maximum 25 characters allowed' },
                            ]}
                        >                
                        <Input
                            showCount
                            maxLength={25}
                            placeholder="e.g., Base Color "

                        />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                            <div style={{ display: 'flex', alignItems: 'center', alignSelf:'center', gap: 10 }}>
                                <div
                                    style={{
                                    backgroundColor: bcName,
                                    width: 24,
                                    height: 24,
                                    borderRadius: 4,
                                    border: '1px solid #ddd',
                                    flexShrink: 0,
                                    }}
                                />
                            </div>
                    </Col>
                </Row>


                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(false)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit & Create New Base Color
                        </Button>}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default BcModal;